const DEFAULT_MODELS = [
  { provider: 'openai', id: 'gpt-4.1', name: 'GPT-4.1', supports_reasoning: false },
  { provider: 'openai', id: 'gpt-4.1-mini', name: 'GPT-4.1 mini', supports_reasoning: false },
  { provider: 'openai', id: 'gpt-4.1-nano', name: 'GPT-4.1 nano', supports_reasoning: false },
  { provider: 'openai', id: 'gpt-4o-mini', name: 'GPT-4o mini', supports_reasoning: false },
  { provider: 'openai', id: 'gpt-5.5', name: 'GPT-5.5', supports_reasoning: true },
  { provider: 'openai', id: 'gpt-5.5-pro', name: 'GPT-5.5 Pro', supports_reasoning: true },
  { provider: 'google', id: 'gemini-2.5-pro', name: 'Gemini 2.5 Pro', supports_reasoning: true },
  { provider: 'google', id: 'gemini-2.5-flash', name: 'Gemini 2.5 Flash', supports_reasoning: true },
  { provider: 'google', id: 'gemini-3-pro', name: 'Gemini 3 Pro', supports_reasoning: true },
  { provider: 'google', id: 'gemini-3.1-pro', name: 'Gemini 3.1 Pro', supports_reasoning: true },
];

const DEFAULT_REASONING_EFFORTS = ['low', 'medium', 'high'];
const DEFAULT_MODEL_PREFERENCE = [
  'gpt-4.1-nano',
  'gpt-4o-mini',
  'gpt-4.1-mini',
  'gpt-4.1',
  'gpt-5.5',
  'gpt-5.5-pro',
];

export const llmConfig = () => window.chatwootConfig?.llmConfig || {};

export const allowedLlmModels = () => {
  const models = llmConfig().allowedModels;
  return Array.isArray(models) && models.length ? models : DEFAULT_MODELS;
};

export const defaultLlmModel = () => {
  const models = allowedLlmModels();
  const modelIds = models.map(model => model.id);
  const configuredDefault = llmConfig().defaultModel;

  if (configuredDefault && modelIds.includes(configuredDefault)) {
    return configuredDefault;
  }

  return (
    DEFAULT_MODEL_PREFERENCE.find(modelId => modelIds.includes(modelId)) ||
    models[0]?.id ||
    'gpt-4.1-nano'
  );
};

export const findLlmModel = modelId =>
  allowedLlmModels().find(model => model.id === modelId);

export const modelSupportsReasoning = modelId =>
  !!findLlmModel(modelId)?.supports_reasoning;

export const reasoningEffortOptions = modelId => {
  const model = findLlmModel(modelId);
  const efforts = model?.reasoning_efforts || llmConfig().reasoningEfforts;
  return Array.isArray(efforts) && efforts.length ? efforts : DEFAULT_REASONING_EFFORTS;
};

export const llmModelOptions = () =>
  allowedLlmModels().map(model => ({
    ...model,
    label: model.name || model.label || model.id,
  }));
